import * as React from "react";

import ErrorMessage, { FormContainer, FormContainerWrapper, LoginImage, RootContainer, TextContainer } from "./components";

import noImage from "@assets/img/noimage.jpeg";
import Api from "@services/Api";
import { RootState } from "@services/Redux";
import { useSelector } from "react-redux";
import ReactGA from "react-ga4";
import MetaPixel from "@utils/meta/MetaPixel";

const ForgotPasswordScreen: React.FC = () => {
  const companyData = useSelector((state: RootState) => state.company.data);
  const [errorMessage, setErrorMessage] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [loading, setLoading] = React.useState(false);

  const handleSubmit = async () => {
    try {
      setErrorMessage("");
      setLoading(true);
      await Api.post(`/user/request_password_reset_token`, { email, company_code: companyData.code });
      ReactGA.event({ action: "request_password_reset", category: "Login", label: "Usuário requisitou reset de senha" });
      MetaPixel.trackCustom("request_password_reset", { category: "Login", label: "Usuário requisitou reset de senha" });
      setLoading(false);
      alert("Um email foi enviado para você com as instruções para resetar sua senha, verifique sua caixa de entrada e spam.");
    } catch (error: any) {
      setLoading(false);
      alert(error.response.data.userMessage);
      setErrorMessage(error?.response?.data?.userMessage ?? "erro de conexão");
    }
  };

  const companyImage = `${companyData?.logo_image?.base_url}/companies/${companyData?.id}/media/thumb_1/${companyData?.logo_image?.key}`;

  return (
    <RootContainer>
      <FormContainerWrapper>
        <LoginImage src={companyImage ?? noImage} width={60} height={60} alt="company-logo" />
        <TextContainer>
          <h2>{companyData.name}</h2>
          <span>Forneça seu email</span>
        </TextContainer>
        <FormContainer>
          <form>
            <div className="form-group">
              <label htmlFor="email">Seu email</label>
              <input
                type="email"
                className="form-control"
                id="email"
                aria-describedby="emailHelp"
                placeholder="Digite seu email"
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
              />
            </div>
            <ErrorMessage message={errorMessage} />
            <button
              type="submit"
              className="btn btn-primary w-100 mt-2"
              disabled={loading}
              onClick={(e) => {
                e.preventDefault();
                handleSubmit();
              }}
            >
              Enviar
            </button>
          </form>
        </FormContainer>
      </FormContainerWrapper>
    </RootContainer>
  );
};

export default ForgotPasswordScreen;
